<template>
  <div>
    <h2>Agenda</h2>
    <v-container class="my-5">
      <v-layout column wrap>
        <v-flex xs12 sm2 md3 lg2 v-for="item in result" :key="item.index">
          <v-card color="teal lighten-3">{{ item }}</v-card>
          <v-layout row wrap class="justify-center">
            <v-flex
              xs12
              sm4
              md2
              lg2
              v-for="item in mapsalida[item]"
              :key="item.id"
            >
              <v-card v-bind:id="item.id" class="ma-2">
                <v-card-text>
                  <b> Fecha </b> <br />
                  {{ item.fecha }} <br />
                  <b>Horario</b> <br />
                  {{ item.inicio }}-{{ item.fin }}
                </v-card-text>
                <v-card-actions class="justify-center">
                  <v-btn
                    outlined
                    :key="item.index"
                    :value="btnTexto"
                    @click="
                      horarioSel(
                        item.id,
                        item.taller,
                        item.fecha,
                        item.inicio,
                        item.fin
                      )
                    "
                  >
                    {{ btnTexto }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
          <br />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import { horarios } from "../api";
export default {
  name: "agenda-comp",
  data: function () {
    return {
      items: [],
      columnas: null,
      filas: "",
      result: [],
      selection: 1,
      active: true,
      tomar: false,
      btncolor: "teal",
      btnTexto: null,
      btnModel: null,
      mapsalida: {},
      valid: false,
      //validación
      nombres: [],
      horariosSeleccionados: [],
      contadorTalleres: 0,
      fechas: [],
      horariosCruces: [],
      ids: [],
      arrayparcial: [],
      nuevoHorario: null,
    };
  },
  computed: {
    ...mapState(["horariosStore", "slugId"]),
  },

  methods: {
    fetchHorarios() {
      //this.consultando = true;
      axios
        .get(horarios(this.$store.state.slugId))
        .then((response) => {
          //console.log(response);
          this.items = response.data.results;
          this.numFilas();
          this.numColumnas();
        })
        .catch((error) => {
          console.log("Error");
          console.log(error);
        })
        .then(() => {
          //this.consultando = false;
        });
    },
    numFilas() {
      // evalua si se repite un taller del response.data y lo elimina de la lista
      var map = {};

      for (var i = 0; i < this.items.length; i++) {
        if (!(this.items[i].taller in map)) {
          map[this.items[i].taller] = true;
          this.result.push(this.items[i].taller);
        }
      }
      return this.result;
    },

    numColumnas() {
      for (var i = 0; i < this.items.length; i++) {
        this.mapsalida[this.items[i].taller] = this.items.filter(
          (item) => item.taller === this.items[i].taller
        );
      }
    },
    cruceHorarios(id, fecha, inicio, fin) {
      var filtro = this.arrayparcial.filter(function (el) {
        return el.fecha === fecha;
      });
      for (var i = 0; i < filtro.length; i++) {
        var hora1i = filtro[i].inicio.substr(0, 2);
        var min1i = filtro[i].inicio.substr(3, 2);
        var concatenacion1 = hora1i.concat(min1i);
        var hinicial1 = parseInt(concatenacion1);

        var hora1f = filtro[i].fin.substr(0, 2);
        var min1f = filtro[i].fin.substr(3, 2);
        var concatenacion2 = hora1f.concat(min1f);
        var hfinal1 = parseInt(concatenacion2);
        var dur1 = hfinal1 - hinicial1;

        var hora2i = inicio.substr(0, 2);
        var min2i = inicio.substr(3, 2);
        var concatenacion3 = hora2i.concat(min2i);
        var hinicial2 = parseInt(concatenacion3);

        var hora2f = fin.substr(0, 2);
        var min2f = fin.substr(3, 2);
        var concatenacion4 = hora2f.concat(min2f);
        var hfinal2 = parseInt(concatenacion4);
        var dur2 = hfinal2 - hinicial2;

        if (hinicial1 == hinicial2) {
          this.validaH = true;
        } else {
          if (hinicial1 >= hinicial2 + dur2) {
            this.validaH = false;
          } else {
            if (hinicial1 + dur1 <= hinicial2) {
              this.validaH = false;
            } else {
              this.validaH = true;
              //alert("Presenta un cruce de horarios. Por favor revisar");
            }
          }
        }
      }
    },

    horario(id, fecha, inicio, fin) {
      this.fecha = fecha;
      this.inicio = inicio;
      this.fin = fin;
      this.id = id;
    },

    horarioSel(id, nombreTaller, fecha, inicio, fin) {
      if (this.contadorTalleres < 5) {
        if (!this.ids.includes(id)) {
          if (!this.nombres.includes(nombreTaller)) {
            if (!this.fechas.includes(fecha)) {
              this.nombres.push(nombreTaller);
              this.ids.push(id);
              this.fechas.push(fecha);
              this.cambiarEstadoBtn(id);
              this.contadorTalleres++;
              this.nuevoHorario = new this.horario(id, fecha, inicio, fin);
              this.arrayparcial.push(this.nuevoHorario);
            } else {
              //cruce de horarios
              this.cruceHorarios(id, fecha, inicio, fin);

              if (this.validaH) {
                alert(
                  "Los talleres presentan un cruce de horarios. Por favor revise las fechas"
                );
              } else {
                this.nombres.push(nombreTaller);
                this.ids.push(id);
                this.fechas.push(fecha);
                this.cambiarEstadoBtn(id);
                this.contadorTalleres++;
                this.nuevoHorario = new this.horario(id, fecha, inicio, fin);
                this.arrayparcial.push(this.nuevoHorario);
              }
            }
          } else {
            alert(
              "Ya tiene seleccionado un horario para el taller: " +
                nombreTaller +
                ". Solo se permite inscribirse a un horario por taller "
            );
          }
        } else {
          this.removeItemFromArr(this.ids, id);
          this.removeItemFromArr(this.nombres, nombreTaller);
          this.cambiarEstadoBtn(id);
          this.removeItemFromArr(this.fechas, fecha);
          this.contadorTalleres--;
          this.arrayparcial = this.arrayparcial.filter(function (el) {
            return el.id !== id;
          });
        }
      } else {
        if (!this.ids.includes(id)) {
          alert("El número máximo de talleres permitidos es 5");
        } else {
          this.removeItemFromArr(this.ids, id);
          this.removeItemFromArr(this.nombres, nombreTaller);
          this.cambiarEstadoBtn(id);
          this.removeItemFromArr(this.fechas, fecha);
          this.contadorTalleres--;
          this.arrayparcial = this.arrayparcial.filter(function (el) {
            return el.id !== id;
          });
        }
      }
    },

    removeItemFromArr(arr, item) {
      var i = arr.indexOf(item);
      if (i !== -1) {
        arr.splice(i, 1);
      }
    },

    cambiarEstadoBtn(id) {
      var doc = document.getElementById(id);
      var clase = doc
        .getElementsByTagName("button")[0]
        .classList.toggle("btncss");
      clase
        ? (doc
            .getElementsByTagName("button")[0]
            .getElementsByTagName("span")[0].innerHTML = "Dejar")
        : (doc
            .getElementsByTagName("button")[0]
            .getElementsByTagName("span")[0].innerHTML = "tomar");
    },
  },

  mounted() {
    this.fetchHorarios();
    this.btnTexto = "tomar";
    //console.log("map: ", this.mapsalida);
  },

  watch: {
    ids: function () {
      this.$store.commit("setHorarios", this.ids);
    },
  },
};
</script>

<style lang="scss" scoped>
.btncss {
  background-color: #4db6ac;
  color: #f0f0f0;
}
nav li {
  display: inline-block;
  background-color: rgb(129, 181, 211);
  border: 1px solid rgb(20, 72, 92);
  text-align: center;
  color: #fff;
  margin: 5px;
}

.tallerdiv {
  border: rgb(141, 151, 156) 1px solid;
}
</style>